<template>
  <div
    class="multibooking-sidebar"
  >
    <div class="multibooking-sidebar-details">
      <div ref="header" class="multibooking-details-header">
        <header-close :deactivate="onReject" />
        <div class="title">{{tc('booking.multiBookingSidebarHeaderTitle')}}</div>
      </div>
      <div class="multibooking-details-scroll" :style="[{ height: scrollHeight + 'px' }]">
        <div class="multibooking-details-wrapper">
          <div class="multibooking-details-title">
            {{tc('booking.multiBookingSidebarTitle')}}
          </div>
          <div class="multibooking-details-description">
            {{tc('booking.multiBookingSidebarDesc',  { quantity: remainingRoomsQuantity })}}
          </div>
          <div class="stay-overview-card">
            <div class="stay-image">
              <picture
                class="image-wrapper"
                v-lazyload="{
                  src: multiBookingSidebarData.sitecoreContent.room.image,
                  variant: 'room-overview'
                }"
              >
                <img
                  class="image"
                  src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                  :alt="multiBookingSidebarData.sitecoreContent.room.title"
                />
              </picture>
            </div>
            <div class="stay-description">
              <div class="stay-description-line box">
                <div class="section-label">{{tc('noums.roomSingular')}} 1</div>
                <div class="overview-item guests">
                  <div class="item-label bold-item">
                    {{multiBookingSidebarData.sitecoreContent.room.title}} | {{multiBookingSidebarData.sitecoreContent.bed.title}}
                  </div>
                  <div class="item-value section-label" v-html="stayGuestsSummary" />
                </div>
                <hr>
                <div class="section-label rate-label">{{tc('noums.rateSingular')}}</div>
                <div class="overview-item">
                  <div class="item-label bold-item">
                    {{multiBookingSidebarData.sitecoreContent.rate.title}}
                  </div>
                  <div class="item-value">
                    <div>{{avgPerNight}}</div>
                    <div class="section-label capitalize">
                      {{tc('booking.avgPerNight')}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div ref="footer" class="multibooking-details-footer multibooking-cta-wrapper">
        <div
          class="multibooking-sidebar-cta"
        >
          <button
              class="decline"
            @click="onReject"
            @keydown.space.prevent="onReject"
          >
            <span>
              {{tc('booking.multiBookingButtonRefuse')}}
            </span>
          </button>
          <button
            class="accept"
            :class="[{ loading: isLoading }]"
            @click="onConfirm"
            @keydown.space.prevent="onConfirm"
          >
            <span>
              {{tc('booking.multiBookingButtonAgree')}}
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import TabTrapMixin from '@mixins/tab-trap'
  import Tracking from '@mixins/tracking'
  import { mapGetters, mapState } from 'vuex'
  import HeaderClose from '../../../booking-widget/components/header-close/header-close.vue'

  export default {
    name: 'multibooking-sidebar',
    components: {
      HeaderClose
    },
    props: {
      prop1: {

      },
    },
    mixins: [TabTrapMixin, Tracking],
    data: () => ({
      scrollHeight: 'auto',
      isLoading: false,
    }),
    computed: {
      ...mapState('responsive', ['height']),
      ...mapState('cart', ['multiBookingSidebarData']),
      ...mapState('booking', ['query']),
      ...mapState('modifyReservation', ['isBookingEditMode']),
      ...mapGetters('i18n', ['tc']),
      ...mapGetters('cart', ['itemsInCart', 'getResolveMultiBookingSidebar']),
      ...mapGetters('booking', ['getSummaryDetails', 'getQuery', 'bookingFlow']),
      ...mapGetters('currency', ['getDisplayPrice']),

      stayGuests() {
        return {
          adultGuestCount: this.multiBookingSidebarData.adultGuestCount,
          childGuestCount: this.multiBookingSidebarData.childGuestCount
        }
      },
      stayGuestsSummary() {
        return this.getSummaryDetails({ customQuery: this.stayGuests, separator: ',<br>' })
      },
      totalPerNight() {
        return this.multiBookingSidebarData ? this.multiBookingSidebarData.nightlyRates.map(n => Number(n.price)).reduce((a, b) => a + b) : 0
      },
      avgPerNight() {
        return this.getDisplayPrice({price: this.totalPerNight / this.multiBookingSidebarData.nightlyRates.length})
      },
      remainingRoomsQuantity() {
        return Number(this.query.roomQuantity) - 1
      },
    },
    watch: {
      height() {
        this.calculateScroll()
      }
    },
    mounted() {
      this.calculateScroll()

      this.$track(this.getTrackingData(this.isBookingEditMode ? 'modifyReservation' : 'booking', this.getQuery, {
        event: 'bookingStateChange',
        bookingEngine: {
          bookingStepNumber: this.isBookingEditMode ? '1.2' : '2.2',
          bookingStepName: this.isBookingEditMode ? 'Selected Room Flyout' : 'Book All Rooms',
          bookingEngineVersion: this.isBookingEditMode ? '2' : '1',
          bookingFlow: this.bookingFlow()
        }
      }))
    },
    methods: {
      onConfirm() {
        if (typeof this.getResolveMultiBookingSidebar === 'function') {
          this.isLoading = true
          this.getResolveMultiBookingSidebar(true)
        }
      },
      onReject() {
        if (typeof this.getResolveMultiBookingSidebar === 'function') {
          this.getResolveMultiBookingSidebar(false)
        }
      },
      calculateScroll() {
        const headerHeight = this.$refs.header?.getBoundingClientRect().height ?? 0
        const footerHeight = this.$refs.footer?.getBoundingClientRect().height ?? 0
        this.scrollHeight = this.height - headerHeight - footerHeight
      },
    }
  }
</script>
